export const makeFieldObject = ([fieldName, fieldValue]) => ({
  fieldName: fieldName.replace(/[A-Z]/g, v => ` ${v}`).replace(/_/g, ' '),
  fieldValue: fieldValue || 'Not found',
});
